import $ from 'jquery'
import _ from 'underscore'
import ViewTTStore from '../ViewTTStore'
import TemplateView from "../../../TemplateView";

const SignatureSettingsSection = function($containerEl, elementsIdPrefix)
{
    TemplateView.call(this, $containerEl);
    this.elementsIdPrefix = elementsIdPrefix;
};

SignatureSettingsSection.prototype = _.create(TemplateView.prototype, {
    html: "<div class='signatureSettingsSection dataLayoutSection'>" +
          "  <div>" +
          "    <table>" +
          "      <tr>" +
          "        <td><input id='<%=id%>_signatureSettings_showSignature' type='checkbox' class='showSignature'/></td>" +
          "        <td><label for='<%=id%>_signatureSettings_showSignature'><%=showSignatureLabel%></label></td>" +
          "      </tr>" +
          "    </table>" +
          "  </div>" +
          "  <div class='selectorContainer showSignatureSelectorCt'>" +
          "    <table>" +
          "      <tr>" +
          "        <td><input id='<%=id%>_signatureSettings_showSignatureRadio' type='radio' name='showSignature' class='eachPage'/></td>" +
          "        <td><label for='<%=id%>_signatureSettings_showSignatureRadio'><%=eachPageLabel%></label></td>" +
          "      </tr>" +
          "      <tr>" +
          "        <td><input id='<%=id%>_signatureSettings_hideSignatureRadio' type='radio' name='showSignature' class='lastPage'/></td>" +
          "        <td><label for='<%=id%>_signatureSettings_hideSignatureRadio'><%=lastPageLabel%></label></td>" +
          "      </tr>" +
          "    </table>" +
          "  </div>" +
          "</div>",

    templateModel: function()
    {
        return { id: this.elementsIdPrefix }
    },

    afterRender: function()
    {
        this.$showSignatureCheckbox = this.findAndBindClick(".showSignature", this._onParameterClick);
        this.$eachPageRadio = this.findAndBindClick(".eachPage", this._onParameterClick);
        this.$lastPageRadio = this.findAndBindClick(".lastPage", this._onParameterClick);
    },

    update: function()
    {
        var printParameters = ViewTTStore.getPrintParametersForSave();
        this.$showSignatureCheckbox.attr("checked", printParameters.showSignature);
        this.$eachPageRadio.attr("checked", printParameters.showSignatureOnEachPage);
        this.$lastPageRadio.attr("checked", !printParameters.showSignatureOnEachPage);
        this._updateClasses();
    },

    messageKeys: function()
    {
        return {
            showSignatureLabel: "view_tt.pdf_settings_preview.show_signature",
            eachPageLabel: "view_tt.pdf_settings_preview.show_signature.each_page",
            lastPageLabel: "view_tt.pdf_settings_preview.show_signature.last_page"
        }
    },

    collectPrintParameters: function()
    {
        return {
            showSignature: !!this.$showSignatureCheckbox.attr("checked"),
            showSignatureOnEachPage: !!this.$eachPageRadio.attr("checked")
        }
    },

    _updateClasses: function()
    {
        this.$el.toggleClass("showSignature", !!this.$showSignatureCheckbox.attr("checked"));
    },

    _onParameterClick: function()
    {
        this._updateClasses();
        $(this).trigger("change");
    }
});

export default SignatureSettingsSection


// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdfSettingsPreview/SignatureSettingsSection.js